import React, { useState, useEffect } from "react";
import Data from "../App";
import { map, distinctUntilChanged } from "rxjs/operators";
import CompJsonEdit from "./CompJsonEdit";
import { fromJS, List } from "immutable";

const State = ({ state, editing, expanded, onChange }) => {
  function getEditIndexForAttr(attrId, changer) {
    if (changer.get("edits")) {
      let editIndex = changer
        .get("edits")
        .findIndex(edit => edit.get("target") === attrId);
      return editIndex;
      //if (editIndex) return edit.get("value");
    }
    return -1;
  }
  function addAttr(isAction) {
    let newAttr = fromJS({ name: "tbd" });
    if (isAction) newAttr = newAttr.set("isAction", true);
    if (state.get("attributes")) {
      let sortedDesc = state
        .get("attributes")
        .sort((a, b) => b.get("id") - a.get("id"));
      let newId = sortedDesc.get(0).get("id") + 1;
      onChange(
        state.updateIn(["attributes"], list =>
          list.push(newAttr.set("id", newId))
        )
      );
    } else {
      onChange(state.set("attributes", new List([newAttr.set("id", 1)])));
    }
  }
  function addChanger() {
    let newAttr = fromJS({ event: "tbd" });
    if (state.get("stateChangers")) {
      onChange(state.updateIn(["stateChangers"], list => list.push(newAttr)));
    } else {
      onChange(state.set("stateChangers", new List([newAttr])));
    }
  }
  function onChanger(obj) {
    console.log("onChanger " + obj);
    onChange(obj);
  }
  function changeStateChanger(changerIndex, editIndex, targetId, newValue) {
    if (editIndex >= 0) {
      onChanger(
        state.setIn(
          ["stateChangers", changerIndex, "edits", editIndex, "value"],
          newValue
        )
      );
    } else {
      let newEdit = fromJS({ target: targetId, value: newValue });
      if (
        state
          .get("stateChangers")
          .get(changerIndex)
          .get("edits")
      ) {
        onChanger(
          state.updateIn(["stateChangers", changerIndex, "edits"], list =>
            list.push(newEdit)
          )
        );
      } else {
        onChanger(
          state.setIn(
            ["stateChangers", changerIndex, "edits"],
            new List([newEdit])
          )
        );
      }
    }
  }
  if (!state) return "";

  let editBox = "";
  if (editing)
    editBox = (
      <CompJsonEdit
        json={JSON.stringify(state)}
        onSet={newObj => onChange(newObj)}
        filterFct={item => true}
      />
    );
  let adding = "";
  if (editing)
    adding = (
      <div>
        <span
          className="CompAddItem"
          onClick={e => {
            e.stopPropagation();
            addAttr(false);
          }}
        >
          +Attribute
        </span>
        <span
          className="CompAddItem"
          onClick={e => {
            e.stopPropagation();
            addAttr(true);
          }}
        >
          +Action
        </span>
        <span
          className="CompAddItem"
          onClick={e => {
            e.stopPropagation();
            addChanger();
          }}
        >
          +Changer
        </span>
      </div>
    );
  return (
    <div>
      {adding}
      <table className="StateTable">
        <tr>
          {!state.get("stateChangers") || !(expanded || editing)
            ? ""
            : state.get("stateChangers").map((changer, index) => (
                <td key={index} className="StateChangerEvent">
                  {editing ? (
                    <input
                      type="text"
                      value={changer.get("event")}
                      onChange={e =>
                        onChange(
                          state.setIn(
                            ["stateChangers", index, "event"],
                            e.target.value
                          )
                        )
                      }
                    />
                  ) : (
                    changer.get("event")
                  )}
                </td>
              ))}
          <td />
        </tr>
        {state.get("attributes").map((attr, index) => (
          <tr key={attr.get("id")}>
            {!state.get("stateChangers") || !(expanded || editing)
              ? ""
              : state.get("stateChangers").map((changer, index) => {
                  let editIndex = getEditIndexForAttr(attr.get("id"), changer);
                  let editVal =
                    editIndex >= 0
                      ? changer
                          .get("edits")
                          .get(editIndex)
                          .get("value")
                      : "";
                  return (
                    <td key={index} className="StateEdit">
                      {editing ? (
                        <input
                          type="text"
                          value={editVal}
                          onChange={e =>
                            changeStateChanger(
                              index,
                              editIndex,
                              attr.get("id"),
                              e.target.value
                            )
                          }
                        />
                      ) : (
                        editVal
                      )}
                    </td>
                  );
                })}
            <td className={attr.get("isAction") ? "StateAction" : "StateAttr"}>
              {editing ? (
                <input
                  type="text"
                  value={attr.get("name")}
                  onChange={e =>
                    onChange(
                      state.setIn(["attributes", index, "name"], e.target.value)
                    )
                  }
                />
              ) : (
                attr.get("name")
              )}
            </td>
          </tr>
        ))}
      </table>
      {editBox}
    </div>
  );
};
export default State;



// WEBPACK FOOTER //
// ./src/components/State.js